import axios from "axios";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
import { clearAuthData, removeAuthorization } from "../../../helpers/api_helper";

    const AUTHORITIES = ['ADMIN', 'MERCHANT', 'COLLABORATOR'];
    const setAuthorization = (token) => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    };

    
    export const authUser = async (data) => {
        try {
            const response = await axios.post(process.env.REACT_APP_API_AUTH+'/auth/login', data, { headers: {'Content-Type': 'application/json'}, });
            
            const accessToken = response?.data?.token;
            const refreshToken = response.data.refreshToken;

            setAuthorization(accessToken);
            const tokenParsed = jwtDecode(accessToken);
            const roles = tokenParsed.roles || [];
            
            const authorizedRoles = roles.filter(role => AUTHORITIES.includes(role));
            
            if (authorizedRoles.length > 0) {
                saveUserToSessionStorage(response?.data, refreshToken);
                return { 
                    roles: authorizedRoles,
                    isAuthorized: true,
                    isNewMerchant: response?.data?.user?.newMerchant,
                    name: response?.data?.user.firstName +" "+ response?.data?.user.lastName,
                    kycVerified: authorizedRoles.includes("COLLABORATOR") ? true : response?.data?.user?.kycVerified
                };

            } else {
                toast.error("Vous n'avez pas les rôles requis.");
                return { roles: authorizedRoles, isAuthorized: false };
            }
        } catch (error) {
            // console.log('auth error', error.response)
            return Promise.reject(error?.response?.data?.message || error?.response?.data?.error);
        }
    };

    export const saveUserToSessionStorage = (response) => {
        if (response) {
            const user =  response?.user ;
            sessionStorage.setItem(response?.role == 'ADMIN' ? 'authAdmin' : 'authUser', JSON.stringify({
                token: response?.token,
                refreshToken: response.refreshToken,
                firstname:user?.firstName,
                lastname:user?.lastName,
                username:user?.username,
                email:user?.email,
                kycVerified:user?.kycVerified,
                roles: response?.role,
                superAdminId:user?.superAdminId,
                userId: response?.user?.id,
                user:response?.user,
                isAdmin: response?.role.includes('ADMIN'),
                twoFaEnabled: response?.user?.twoFaEnabled,
                kycStatus: response?.user?.kycStatus,
                adminImpersonation : response?.adminImpersonation,
                otpLoginEnabled : user?.otpLoginEnabled || response?.otpLoginEnabled,
            }));
        }
    };

    export const logout = () => {
        sessionStorage.clear();
        clearAuthData();
        removeAuthorization();
        window.location.href = "/login";
    };

    export const registerMerchand = async (data) => {
        try {
        const response = await axios.post(process.env.REACT_APP_API_AUTH+`/auth/signup-merchant`, data);
        return response;
        } catch (error) {
        throw error;
        }
    };
    export const sendForgotPasswordRequest = async (data) => {
        try {
        const response = await axios.post(`${process.env.REACT_APP_API_AUTH}/forgot-password`, data);
        return response;
        } catch (error) {
        throw error;
        }
    };

    export const updateForgetPassword = async (data) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_API_AUTH}/reset-password`, null,
                { params: { 
                        token : data.token,
                        newPassword: data.newPassword
                    }
                }
            );
            return response;
        } catch (error) {
        throw error;
        
        }
    };

    export const updatePassword = async (data) => {
        try {
        const response = await axios.put(`${process.env.REACT_APP_API_AUTH}/auth/modify-password`, data);
        return response.data;
        } catch (error) {
        throw error;
        }
    };

